import { KalturaTagFilter, TagListAction } from '@kaltura-ott/ott-client-types/api/types';
import { KalturaFilterPager } from '@kaltura-ott/ott-client-types/api/types/KalturaFilterPager';

import { kalturaClient } from './kaltura-clent';

export const getTagsByMeta = (metaId: number, pager?: KalturaFilterPager) => {
  const client = kalturaClient();
  const _pager: KalturaFilterPager = new KalturaFilterPager({
    pageSize: 50,
    pageIndex: 1,
  });
  const filter = new KalturaTagFilter({
    typeEqual: metaId,
  });
  const action = new TagListAction({
    filter,
    pager: pager || _pager,
  });
  return client.request(action);
};
